import service from '@/services/types/institucionExoneracion'

export const namespaced = true;

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => {
    state.list = objs
  }
}

export const actions = {
  list: ({ commit, state }, value) => (state.list?.length ? state.list : service.list(value).then(result => commit('LIST', result) || result))
}

export const getters = {
  get_Id: state => value => state.list.length !== 0 ? state.list.find(item => item.value === value).id : null,
  getValue: state => _id => state.list.length !== 0 ? state.list.find(item => item.id === _id)?.value : null
}
